module.exports = __webpack_public_path__ + "img/01.0050f1a6.png";